// extracted by mini-css-extract-plugin
export var actionButton = "_q4-0";
export var actionMenuContainer = "_q4-i";
export var bubble = "_q4-2";
export var bubbleActionMenu = "_q4-j";
export var bubbleContext = "_q4-6";
export var bubbleItems = "_q4-7";
export var customer = "_q4-3";
export var divider = "_q4-8";
export var fileList = "_q4-9";
export var hiddenComment = "_q4-o";
export var infoAbove = "_q4-a";
export var internal = "_q4-4";
export var lightActionButton = "_q4-1";
export var link = "_q4-b";
export var merchant = "_q4-5";
export var message = "_q4-c";
export var profilePicture = "_q4-e";
export var quillToolbarContainer = "_q4-f";
export var senderDate = "_q4-g";
export var senderDateCustomer = "_q4-h";
export var senderName = "_q4-d";
export var time = "_q4-k";
export var uploadedImage = "_q4-l";
export var username = "_q4-m";
export var xsmall = "_q4-n";